var bindingErrorPrefix = 'Binding error:';
var calcErrorPrefix = 'Calc error:';
var eventsErrorPrefix = 'Events error:';
var arrayErrorPrefix = 'Matreshka.Array error:';
var getType = function getType(variable) {
  if (variable === null) {
    return 'null';
  }
  return typeof variable;
};
var getTypeError = function getTypeError(variable, variableName, expectedType) {
  return variableName + " must have type \"" + expectedType + "\" but got \"" + getType(variable) + "\" instead.";
};
// each message gets the details its caller passes
var errors = {
  'common:object_type': function commonObject_type(_ref) {
    var object = _ref.object,
      method = _ref.method;
    return "Error in " + method + ": " + getTypeError(object, 'object', 'object');
  },
  'common:call_class': function commonCall_class() {
    return 'Cannot call a class as a function';
  },
  'common:use_magic_props': function commonUse_magic_props() {
    return '"sandbox" key (for all objects) and "container" key (for Matreshka.Array instances)' + ' are reserved for service use and cannot be used as usual properties';
  },
  'common:not_configurable': function commonNot_configurable(_ref2) {
    var key = _ref2.key;
    return "\"" + key + "\" cannot be made reactive: the property is not configurable" + " (a frozen or sealed object, or a built-in property such as an array's length)";
  },
  'binding:node_missing': function bindingNode_missing(_ref3) {
    var key = _ref3.key,
      node = _ref3.node;
    var selectorInfo = typeof node === 'string' ? " (given selector is \"" + node + "\")" : '';
    return bindingErrorPrefix + " node is missing for key \"" + key + "\"" + selectorInfo + ".";
  },
  'binding:falsy_key': function bindingFalsy_key() {
    return bindingErrorPrefix + " \"key\" arg cannot be falsy";
  },
  'binding:instance_nodes_missing': function bindingInstance_nodes_missing(_ref4) {
    var $nodes = _ref4.$nodes;
    var missing = !$nodes ? '$nodes' : 'nodes';
    return bindingErrorPrefix + " \"" + missing + "\" property of Matreshka instance is missing." + ' It must be an object and must not be reassigned.';
  },
  'binding:magic_props_nodes_length': function bindingMagic_props_nodes_length() {
    return bindingErrorPrefix + " \"sandbox\" key (for all objects) and \"container\" key" + ' (for Matreshka.Array instances) cannot have more than one bound node';
  },
  'calc:target_type': function calcTarget_type(_ref5) {
    var target = _ref5.target;
    return calcErrorPrefix + " " + getTypeError(target, 'target key', 'string');
  },
  'calc:source_key_type': function calcSource_key_type(_ref6) {
    var sourceKey = _ref6.sourceKey;
    return calcErrorPrefix + " " + getTypeError(sourceKey, 'source key', 'string');
  },
  'calc:source_object_type': function calcSource_object_type(_ref7) {
    var sourceObject = _ref7.sourceObject;
    return calcErrorPrefix + " " + getTypeError(sourceObject, 'source object', 'object');
  },
  'calc:source_type': function calcSource_type(_ref8) {
    var source = _ref8.source;
    return calcErrorPrefix + " " + getTypeError(source, 'source', 'object');
  },
  'array:model_type': function arrayModel_type(_ref9) {
    var Model = _ref9.Model;
    return arrayErrorPrefix + " " + getTypeError(Model, 'Model', 'function');
  },
  'array:add_render_twice': function arrayAdd_render_twice() {
    return arrayErrorPrefix + " one rendered object was inserted twice.";
  },
  'array:rendered_number_nodes': function arrayRendered_number_nodes(_ref0) {
    var length = _ref0.length;
    return arrayErrorPrefix + " renderer returned " + length + " nodes instead of one." + (" " + (length > 0 ? 'To fix this wrap these nodes by single node.' : ''));
  },
  'array:renderer_node_missing': function arrayRenderer_node_missing(_ref1) {
    var selector = _ref1.selector;
    return arrayErrorPrefix + " renderer node is missing (given selector is \"" + selector + "\")";
  },
  'array:method_compat_renderer': function arrayMethod_compat_renderer(_ref10) {
    var method = _ref10.method;
    return arrayErrorPrefix + " Not possible to render when " + method + " method is called";
  },
  'pull:to_remove_type': function pullTo_remove_type(_ref11) {
    var toRemove = _ref11.toRemove;
    return "Error in pull: " + getTypeError(toRemove, 'toRemove', 'number');
  },
  'restore:no_nodes': function restoreNo_nodes() {
    return arrayErrorPrefix + " cannot find any container to restore an instance using \"restore\" method";
  },
  'trigger:names_type': function triggerNames_type(_ref12) {
    var names = _ref12.names;
    return eventsErrorPrefix + " " + getTypeError(names, 'event name', 'string');
  },
  'on:names_type': function onNames_type(_ref13) {
    var names = _ref13.names;
    return errors['trigger:names_type']({
      names: names
    });
  },
  'removedatakeys:key_type': function removedatakeysKey_type(_ref14) {
    var key = _ref14.key;
    return "Error in removeDataKeys: " + getTypeError(key, 'key', 'string');
  },
  'adddatakeys:key_type': function adddatakeysKey_type(_ref15) {
    var key = _ref15.key;
    return "Error in addDataKeys: " + getTypeError(key, 'key', 'string');
  },
  'remove:key_type': function removeKey_type(_ref16) {
    var key = _ref16.key;
    return "Error in remove: " + getTypeError(key, 'key', 'string');
  },
  'mediate:key_type': function mediateKey_type(_ref17) {
    var key = _ref17.key;
    return "Error in mediate: " + getTypeError(key, 'key', 'string');
  }
};
export default function matreshkaError(key, data) {
  var getError = errors[key];
  if (!getError) {
    throw Error("Unknown error \"" + key + "\". Please report about this on Github.");
  }
  return new Error(getError(data));
}